module.exports = __webpack_public_path__ + "img/m_news.0b031be1.png";